// extracted by mini-css-extract-plugin
module.exports = {"question-blocks":"wAxLgtN","questionBlocks":"wAxLgtN","question-block":"_31ENIfT","questionBlock":"_31ENIfT","header":"QCeeAHC","table":"xaPsKuR"};